import _ from "lodash"

export const SALE_ERRORS = {

    UNIQUE_SALE_PER_CPF_ERROR_MSG: 'Este curso permite apenas uma compra por CPF.',
    ERROR_WITHOUT_IVA_CODE: 'Ocorreu um erro ao cadastrar a compra no sistema, (sem ivaCode).',
    ERROR_DO_SALE: 'Ocorreu um erro ao cadastrar a compra no sistema.',
}

export default function doSale(doSaleRequest) {

    return (  {
        saleResponsible,
        saleBuyer,
        saleRelease,
        saleGuests,
        saleValue,
        unitValue,
        installmentNumber,
        voucherName,
        paymentMethod,
        paymentPartner,

    }) => new Promise(async (resolve, reject) => {

        try {
            const saleResult = await doSaleRequest(
                saleResponsible.code,
                saleBuyer.code,
                saleRelease.code,
                saleGuests,
                saleValue,
                unitValue,
                paymentMethod,
                installmentNumber,
                voucherName,
                paymentPartner
            )


            const errorMessage = _.get(saleResult, 'errorMessages[0]' , '')

            if (errorMessage.startsWith("Ops! Produto não aceita mais de uma compra por CPF"))
                return reject(SALE_ERRORS.UNIQUE_SALE_PER_CPF_ERROR_MSG)


            if (!saleResult.invoiceAccountCode) {
                return reject(errorMessage)
            }


            return resolve(saleResult)


        } catch (e) {
            console.error(e)
            reject(SALE_ERRORS.ERROR_DO_SALE)
        }

    })
}



// WEBPACK FOOTER //
// ./src/_pages/Sale/_functions/do-sale.js